import { Button } from '~/UIKit';
import React from 'react';
import { Formik, Field, Form } from 'formik';
import { TextField } from 'formik-material-ui';
import { TFunction } from 'i18next';
import { Route } from '../../../Constants/Routes.constants';
import { concatenateWithOrigin } from '../../../Helpers/Url.helpers';
import { validateEmail } from '../../../Helpers/Validators.helper';
import { makeStyles } from '~/UIKit/Style';

type EmailFormProps = {
  t: TFunction;
  onSubmitResetEmail: (values: EmailFormState) => void;
};

export interface EmailFormState {
  email: string;
  src_url: string;
}

const useInitialValues = (resetLink: string): EmailFormState => ({
  email: '',
  src_url: resetLink,
});

const useStyles = makeStyles({
  sentEmail: {
    marginTop: 30,
  },
});

export const resetLink = () => concatenateWithOrigin(Route.NEW_PASSWORD);

export const EmailForm = ({ t, onSubmitResetEmail }: EmailFormProps) => {
  const { classes } = useStyles();
  const initalValues = useInitialValues(resetLink());
  return (
    <Formik initialValues={initalValues} onSubmit={onSubmitResetEmail}>
      {() => (
        <Form data-testid="resetEmailForm">
          <Field
            component={TextField}
            data-testid="passwordResetEmail"
            fullWidth
            id="name"
            label={t('app.email')}
            margin="dense"
            name="email"
            type="email"
            validate={validateEmail}
          />
          <Button
            className={classes.sentEmail}
            color="primary"
            data-testid="triggerPasswordReset"
            fullWidth
            type="submit"
            variant="contained"
          >
            {t('recoverPassword.email')}
          </Button>
        </Form>
      )}
    </Formik>
  );
};
